import { ANSWER_TYPES, type RiskAssessmentAnswerType } from "./types";

// 画面下部の集計行（ui-design.md 4.5）専用の表示用集計。
// 保存される判定値はサーバーが再計算した結果であり、ここでの positive はプレビューに過ぎない（NR-001）。
export type RiskAssessmentScoreSummary = {
  applicableCount: number;
  notApplicableCount: number;
  unknownCount: number;
  unansweredCount: number;
  answeredAll: boolean;
  positive: boolean;
};

export type SummarizeAnswersOptions = {
  questionCount: number;
  // 閾値は GET /new の positiveThreshold を渡す（フロントに 7 / 6 をハードコードしない）。
  positiveThreshold: number;
};

type SummarizableAnswer = {
  answerType: RiskAssessmentAnswerType | null;
};

export const summarizeAnswers = (
  answers: readonly SummarizableAnswer[],
  { questionCount, positiveThreshold }: SummarizeAnswersOptions
): RiskAssessmentScoreSummary => {
  const countOf = (answerType: RiskAssessmentAnswerType): number =>
    answers.filter((answer) => answer.answerType === answerType).length;

  const applicableCount = countOf(ANSWER_TYPES.applicable);
  const answeredCount = applicableCount + countOf(ANSWER_TYPES.notApplicable) + countOf(ANSWER_TYPES.unknown);
  const unansweredCount = Math.max(questionCount - answeredCount, 0);

  return {
    applicableCount,
    notApplicableCount: countOf(ANSWER_TYPES.notApplicable),
    unknownCount: countOf(ANSWER_TYPES.unknown),
    unansweredCount,
    answeredAll: unansweredCount === 0 && questionCount > 0,
    positive: applicableCount >= positiveThreshold
  };
};
